<template>
  <div class="user-page">
    <h3 class="mb-4"> {{ $t('general.my_order_past') }}</h3>

    <div class="section-header pb-0 mb-4">
      <div class="section-header-left">
        <input v-model="search" :placeholder="'Siparişlerimde Ara'" class="mt-3" type="text" @input="isTyping = true">
      </div>
      <!-- <div class="section-header-right">
        <select v-model="order_by" class=" ml-3 mb-0" @change="applyFilter">
          <option value="date">{{ $t('certification.order_date') }}</option>
          <option value="name">{{ $t('certification.order_name') }}</option>
        </select>
      </div> -->
    </div>
    <div>
    </div>
    <div class="card">
      <!-- Card header -->
      <div class="card-header actions-toolbar border-0">
        <div class="d-flex justify-content-between align-items-center">
          <!-- <h4 class="d-inline-block mb-0"></h4> -->
          <div class="row" style="width:100%">
            <div class=" col-md-1  search-icon ">
              <i class="uil-search"></i>
            </div>
            <div class="col-md-11 uk-search uk-search-navbar" style="margin-left:-2rem">
              <input class="uk-search-input shadow-0 uk-form-small" type="search" v-model="filter.search"
                :placeholder="$t('general.search')" autofocus="" />
              <!-- <a href="#" class="btn btn-icon btn-hover btn-circle" aria-expanded="false">
                <i class="uil-search"></i>
              </a>
              <div class="uk-drop" uk-drop="mode: hover; pos: right-center; offset: 0" style="left: 91px; top: 159.297px;">
                <form class="uk-search uk-search-navbar uk-width-1-1">
                  <input class="uk-search-input shadow-0 uk-form-small"
                  type="search"
                    v-model="filter.search"
                    :placeholder="$t('general.search')" autofocus="">
                </form>-->
            </div>
          </div>
          <div class="d-flex">
            <!-- Shorting -->
            <a href="#" class="btn btn-icon btn-hover btn-circle" :uk-tooltip="$t('filters.order.sort')" title=""
              aria-expanded="false">
              <i class="uil-list-ui-alt"></i>
            </a>
            <div uk-dropdown="pos: bottom-right ; mode: click ;animation: uk-animation-scale-up" class="uk-dropdown">
              <ul class="uk-nav uk-dropdown-nav">
                <li @click="sortOrder('text', 'asc')">
                  <a href="javascript:void(0)">{{ $t("sorting.a_z") }}</a>
                </li>
                <li @click="sortOrder('text', 'desc')">
                  <a href="javascript:void(0)">{{ $t("sorting.z_a") }}</a>
                </li>
                <li @click="sortOrder('created_at', 'asc')">
                  <a href="javascript:void(0)">
                    {{ $t("sorting.created_at_asc") }}</a>
                </li>
                <li @click="sortOrder('created_at', 'desc')">
                  <a href="javascript:void(0)">
                    {{ $t("sorting.created_at_desc") }}</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <!-- Table -->
      <div class="table-responsive">
        <table class="table align-items-center">
          <thead>
            <tr>
              <th scope="col"> {{ $t('general.product_name') }} </th>
              <th scope="col"> {{ $t('general.product_type') }} </th>
              <th scope="col"> {{ $t('general.order_date') }} </th>
              <th scope="col"> {{ $t('general.price') }} </th>
              <th scope="col"> {{ $t('general.invoice') }} </th>
              <th scope="col"> {{ $t('general.status') }} </th>
              <!-- <th scope="col">Fatura Yükle</th> -->
            </tr>
          </thead>
          <tbody class="list">
            <!--user item-->
            <tr v-for="(order, index) in orders" :key="index">
              <td>{{ order.items[0].title }}</td>
              <td>{{ $t(`general.order.${order.items[0].type}`) }}</td>
              <td>{{ dateFormat(order.created_at) }}</td>
              <td> {{ formatPrice(order.items[0].price, order.items[0].currency) }}</td>
              <td>
                <span v-if="order.invoice_file" class="cursor-pointer text-primary" @click="showInvoiceModal(order)">
                  {{ $t('general.invoice') + page + index + '.pdf' }}
                </span>
                <span v-else>-</span>
              </td>
              <td>{{ $t(`general.order.${order.status}`) }}</td>
              <!-- <td>
                  <div class="upload-container">
                    <button class="btn btn-info upload-btn" @click="triggerFileInput(index)">
                      <i class="uil-upload"></i> {{ $t("general.upload") }}
                    </button>
                    <input type="file" ref="fileInputs" accept=".pdf" class="hidden-input"
                      @change="handleFileUpload($event, order.token)" />
                  </div>
                </td> -->

            </tr>

          </tbody>
        </table>
        <pagination :pagination="pagination" class="mt-2 mb-3" @changePage="setPage($event)"></pagination>
      </div>
    </div>
    <!-- <div class="uk-flex uk-flex-center p-4">
      <button class="btn btn-info button_more" @click.prevent="itemsMoreButton">{{ $t('general.more') }}</button>
    </div> -->

    <!-- Fatura Gösterme modalı -->
    <div id="invoice_modal" class="uk-modal-container" uk-modal>
      <div class="uk-modal-dialog uk-modal-body">
        <button class="uk-modal-close-default" type="button" uk-close></button>
        <div class="uk-modal-body">
          <div v-if="selectedInvoice" class="invoice-container">
            <iframe :src="selectedInvoice" width="100%" height="500px" frameborder="0"></iframe>
            <div class="text-center mt-3">
              <button class="btn btn-primary" @click="downloadInvoice">
                <i class="uil-download-alt"></i> {{ $t('general.download') }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import { GET_ITEMS } from "@/core/services/store/REST.module";
import moment from "moment";
import 'moment/locale/fr';
import 'moment/locale/es';
import 'moment/locale/az';
import 'moment/locale/tr';
import 'moment/locale/en-gb';
import Pagination from "@/assets/components/Pagination";
import { formatPrice } from "@/utils/money";
import { getEnvironmentMediaUrl } from "@/utils/imageHelper";
import bridge from "@/core/services/bridge.service";
import native from "@/mobile/mobile.fileHandler";

export default {
  name: "PaymentHistory",
  components: { Pagination },
  data() {
    return {
      ordersUrl: 'api/purchases',
      orders: [],
      pagination: null,
      page: 1,
      userModal: null,
      filter: {
        search: null,
        order: "desc",
        sort: "created_at",
      },
      userContents: [],
      userModalContent: {},

      sortTitle: this.$t("filters.order.sort"),
      cancelContentInput: '',
      isCancelInputActive: false,
      sortOption: [
        { key: 'text-asc', sort: 'id', order: 'asc', label: this.$t("sorting.a_z") },
        { key: 'text-desc', sort: 'id', order: 'desc', label: this.$t("sorting.z_a") },
        { key: 'created_at-asc', sort: 'created_at', order: 'asc', label: this.$t("sorting.created_at_asc") },
        { key: 'created_at-desc', sort: 'created_at', order: 'desc', label: this.$t("sorting.created_at_desc") },
      ],
      certificationsUrl: 'api/get-certificates',
      certifications: [],
      search: '',
      order_by: 'name',
      sort: 'desc',
      isTyping: false,
      searchResult: [],
      perPage: 10,
      pdf_preview_link: '',
      certificate_download_link: null,
      selectedInvoice: null,
    };
  },
  methods: {
    getEnvironmentMediaUrl,
    formatPrice,
    dateFormat(date) {
      return moment(date).format("DD MMMM YYYY HH:mm")
    },
    getOrders() {
      let self = this;
      this.$store
        .dispatch(GET_ITEMS, {
          url: self.ordersUrl,
          acceptPromise: true,
        })
        .then((result) => {
          if (result.status) {
            this.orders = result.data.data
            // self.experience_shareable = result.data.experience_shareable
            //   ? true
            //   : false;
            // self.company = result.data;
          }
        });
    },
    setPage(page) {
      this.page = page;
      this.applyFilter()
    },
    handleToDownloadPdf(value) {
      if (value)
        this.certificate_download_link = value.certificate_pdf_download_link;
      window.open(this.certificate_download_link, "_blank");
      UIkit.modal("#assignment_certificate_modal").hide();
    },

    handleOnClickCartEducation(value) {
      this.$router.push({ name: 'user.education-detail', params: { id: value } })
    },

    showCertifcateModal(value) {
      this.pdf_preview_link = value.certificate_pdf_preview_link;
      this.certificate_download_link = value.certificate_pdf_download_link;
      UIkit.modal("#assignment_certificate_modal").show();
    },
    itemsMoreButton() {
      let self = this;
      let pageNumber = null;
      if (this.certifications.last_page === this.page) {
        return;
      } else {
        pageNumber = this.page += 1;
        this.$store.dispatch(GET_ITEMS, {
          url: this.certificationsUrl,
          acceptPromise: false,
          filters: {
            'page': pageNumber,
            'perPage': this.perPage,
            'search': this.search,
            'order_by': this.order_by,
          }
        }).then(result => {
          if (result.status) {
            for (let i = 0; i < result.data.data.length; i++) {
              self.certifications.data.push(
                result.data.data[i],
              )
            }
          }
        })
      }
    },
    fixDate(value) {
      return moment(value).locale(this.secureLocalStorage("language")).format('DD MMMM YYYY');
    },
    applyFilter: function (search) {
      let self = this;
      if (this.search) {
        self.certifications = [];
        self.page = 1;
      }
      this.$store.dispatch(GET_ITEMS, {
        url: this.certificationsUrl,
        filters: {
          'page': this.page,
          'perPage': this.perPage,
          'search': this.search,
          'order_by': this.order_by,
        },
        acceptPromise: false,
      }).then(result => {
        self.certifications = result.data.data;
        this.pagination = result.data;
      })
    },
    showInvoiceModal(order) {
      this.selectedInvoice = this.getEnvironmentMediaUrl(order.invoice_file);
      UIkit.modal("#invoice_modal").show();
    },
    downloadInvoice() {
      if (this.selectedInvoice) {
        if (bridge.isNative) {
          native.downloadFile(this.selectedInvoice, 'fatura.pdf', 'application/pdf');
        } else {
          window.open(this.selectedInvoice, '_blank', 'noopener,noreferrer');
        }
      }
    },
  },
  mounted() {
    this.getOrders();

  },
  watch: {
    search: _.debounce(function () {
      this.isTyping = false;
    }, 1000),
    isTyping: function (value) {
      if (!value) {
        this.applyFilter(this.search);
      }
    }
  }
}
</script>

<style scoped>
.button_more {
  border-radius: 50% !important;
  height: 70px;
  width: 70px;
  background-color: var(--backgroundColor) !important;
}

.table td {
  text-transform: capitalize;
}
</style>
